import { Component, input, InputSignal, output, ChangeDetectionStrategy } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { Toast } from '../../../models/local/toast.model';
import { SafePipe } from "../../../pipes/safe.pipe";
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'immo-toast',
  imports: [
    MatIconModule,
    MatRippleModule,
    SafePipe,
  ],
  templateUrl: './toast.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './toast.component.css',
})
export class ToastComponent extends BaseComponent {

  // -----------------------------------------------------------------------------------------------------
  // @ INPUTS
  // -----------------------------------------------------------------------------------------------------

  readonly toast: InputSignal<Toast> = input.required<Toast>();

  // -----------------------------------------------------------------------------------------------------
  // @ OUTPUTS
  // -----------------------------------------------------------------------------------------------------

  readonly dismissed = output<void>();
}
